import { Collection } from "kreate-common/modules/business-types";
import { DisplayableError } from "kreate-common/modules/displayable-error";
import ButtonOutline from "kreate-common/modules/kreate-ui/components/ButtonOutline";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import { httpPost$DeleteCollection } from "kreate-server/commands/DeleteCollection/fetcher";
import * as React from "react";
import { MdDelete } from "react-icons/md";

import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import { useToast } from "@/modules/kreate-contexts/ToastContext";

type Props = {
  open: boolean;
  onSuccess?: () => void;
  onClose?: () => void;
  collection: Collection;
};

export default function ModalRemoveCollection({
  open,
  onClose,
  onSuccess,
  collection,
}: Props) {
  const [busy, setBusy] = React.useState(false);
  const { showMessage } = useToast();
  const handleDelete = async () => {
    setBusy(true);
    try {
      await httpPost$DeleteCollection(
        `/api/v1/collection/${collection.collectionId}/delete`,
        {}
      );
      showMessage({
        title: "Successfully removed collection!",
        color: "success",
      });
      onSuccess?.();
      // shamelesslyRevalidateEverything();
      /** NOTE: thanh-kreate: we should not revalidate at the same time with redirecting
       *  The current page would experience error due to revalidating for a short time
       *  before redirecting
       */
    } catch (error) {
      const displayableError = DisplayableError.from(error);
      showMessage({
        title: displayableError.title,
        description: displayableError.description,
        color: "danger",
      });
    } finally {
      setBusy(false);
    }
  };
  return (
    <ModalV2 open={open} onClose={onClose}>
      <ModalV2.Header
        content={`Delete Collection: ${collection.title || EM_DASH}`}
      />
      <ModalV2.Content className={styles.text}>
        {"Are you sure you want to delete this collection?"}
      </ModalV2.Content>
      <ModalV2.Actions>
        <ButtonOutline content="Cancel" onClick={onClose} disabled={busy} />
        <ButtonPrimary
          content="Delete Collection"
          icon={<MdDelete />}
          onClick={handleDelete}
          disabled={busy}
        />
      </ModalV2.Actions>
    </ModalV2>
  );
}
